export default __webpack_public_path__ + "static/media/img-main-banner.81588deb.png";